import React, { useMemo, useContext } from 'react';
import { getIsArrayEmpty } from 'utils';
import NotificationPlaceholder from 'components/NotificationPlaceholder';
import LeadNotificationsContext from 'providers/LeadNotifications/LeadNotifications.context';
import LeadNotificationCard from 'components/LeadNotificationCard';
import NotificationsContext from 'providers/Notifications/Notifications.context';

export default function useLeadNotifications() {
  const { closeDrawer } = useContext(NotificationsContext);
  const { notifications, fetchingNotifications, numberOfPlaceholders } =
    useContext(LeadNotificationsContext);

  const showEmptyState = useMemo(
    () => !fetchingNotifications && getIsArrayEmpty(notifications),
    [fetchingNotifications, notifications],
  );

  const placeholders = useMemo(
    () => (
      <div className="notifications-placeholders">
        {fetchingNotifications &&
          Array(numberOfPlaceholders)
            .fill(1)
            .map((_, i) => <NotificationPlaceholder key={i} />)}
      </div>
    ),
    [fetchingNotifications, numberOfPlaceholders],
  );

  const renderedCards = useMemo(
    () =>
      notifications.map((notification) => (
        <LeadNotificationCard
          key={notification._id}
          notification={notification}
          onDealClick={closeDrawer}
        />
      )),
    [closeDrawer, notifications],
  );

  return { showEmptyState, placeholders, renderedCards };
}
